import GroupPushVue from '@/views/sa/group-push/group-push.vue';

const basePath = '/sa/group-push';
const role = 'sa'; // 角色身份

export const SA_GROUP_PUSH_INDEX = 'sa-group-push-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: GroupPushVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SA_GROUP_PUSH_INDEX,
      component: () => import(
        /* webpackChunkName: "groupPush" */
        `@/views/${role}/group-push/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
